// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"5e6bb5bc","408":"228f948d","553":"6e43e267"}[chunkId] + ".chunk.js";
};